import { api } from 'data/api/api'

import { PaginationDto } from '@marketplace-web/domain/pagination-data'

import { UserNotificationDto } from '../types/dtos'

type GetUserNotificationsArgs = {
  page: number
  perPage: number
}

type GetUserNotificationsResp = {
  notifications: Array<UserNotificationDto>
  pagination: PaginationDto
}

export const getUserNotifications = ({ page, perPage }: GetUserNotificationsArgs) =>
  api.get<GetUserNotificationsResp>('/notifications', {
    params: {
      page,
      per_page: perPage,
    },
  })
